/*eslint-disable*/

import React, { useEffect, useRef, useState } from "react";

import { FormattedMessage } from "react-intl";

import { DndProvider, useDrag, useDrop } from "react-dnd";

import { FiRefreshCcw } from "react-icons/fi";
import { HiOutlineEllipsisVertical } from "react-icons/hi2";

import { Link } from "react-router-dom";

import FastAPIClient from "../../../client";
import fast_api_config from "../../../config";

// Instantiate the FastAPI client
const client = new FastAPIClient(fast_api_config);

const ItemTypes = {
    CARD: "card",
};

const DraggableMeetingList = ({
    client,
    text,
    time,
    index,
    meeting_id,
    moveCard,
    isLastCard,
    meeting_type,
    selectedDraggable,
    setSelectedDraggable,
    is_recurring,
    is_visited,
    is_lead,
    title,
    alert,
    id,
    meetingData,
    setSelectedMeeting,
    setDetailsTrue,
}) => {
    const ref = useRef(null);

    const [isUpdating, setIsUpdating] = useState(false);
    const [, drop] = useDrop({
        accept: ItemTypes.CARD,
        hover(item, monitor) {
            if (!ref.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = index;

            if (dragIndex === hoverIndex) {
                return;
            }

            const hoverBoundingRect = ref.current?.getBoundingClientRect();
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;

            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }

            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }

            moveCard(dragIndex, hoverIndex);
            item.index = hoverIndex;
        },
    });

    const [{ isDragging }, drag] = useDrag({
        type: ItemTypes.CARD,
        item: () => ({ meeting_id, index }),
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const opacity = isDragging ? 0 : 1;
    drag(drop(ref));

    const showMeetingModal = () => {
        setSelectedMeeting(meetingData);
        setDetailsTrue(true);
    };

    const handleClick = () => {
        setSelectedDraggable(meeting_id);
    };

    // Function to convert text to title case if it's fully uppercase
    const toTitleCaseIfUpper = (str) => {
        if (str && str === str.toUpperCase()) {
            return str
                .toLowerCase()
                .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
        }
        return str;
    };

    return (
        <div
            ref={ref}
            style={{
                borderColor: "#f3f4f6",

                backgroundColor: `${
                    meeting_id === selectedDraggable ? "white" : "white"
                }`,
                cursor: "move",
                opacity,
            }}
            className="w-full relative flex-1"
            onClick={() => handleClick(meeting_id)}
        >
            <div className="flex flex-row">
                <div
                    className={`w-full ml-1 mr-1 ${
                        isLastCard ? "" : "border-b border-gray-200"
                    }`}
                >
                    <div className="flex flex-row items-center pl-2 pr-2 pt-1 pb-1 mb-2">
                        <div className="flex flex-col w-2/3 md:w-5/6 text-left">
                            <div className="flex flex-row w-full">
                                <div className="flex flex-col mb-2 w-full ">
                                    <div className="text-base font-semibold truncate max-w-[300px]">
                                        {title ? (
                                            toTitleCaseIfUpper(title)
                                        ) : (
                                            <FormattedMessage id="routing.no_title" />
                                        )}
                                    </div>{" "}
                                    <div className="text-sm">
                                        {title === text
                                            ? ""
                                            : toTitleCaseIfUpper(text)}
                                    </div>
                                </div>
                                {is_recurring && (
                                    <div className="align-top text-sm ml-3 mt-1">
                                        <FiRefreshCcw />
                                    </div>
                                )}
                                {alert && (
                                    <div className="flex ml-2 flex-row items-center bg-gold rounded-full text-black text-xxxs font-bold text-center mb-2 pl-1 pr-1 whitespace-nowrap flex-shrink-0 h-[25px]">
                                        <div className="">
                                            {" "}
                                            <FormattedMessage
                                                id="routing.new_reco"
                                                values={{ number: 1 }}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="w-2/3 text-black text-sm text-left mb-2">
                                {time.start} - {time.end}
                            </div>
                        </div>
                        <div className="flex flex-col w-1/3 left">
                            <div className="flex flex-row w-full">
                                <div className="w-5/6"></div>
                                <div className="w-1/6 ">
                                    {!is_visited && (
                                        <button
                                            onClick={() => showMeetingModal()}
                                            className="text-black hover:bg-gray-300 hover:rounded-full disabled:text-gray-300 text-lg"
                                            disabled={isUpdating}
                                            title="Afficher plus" // French for "Show more"
                                        >
                                            <HiOutlineEllipsisVertical />
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div className="left mb-4"> </div>
                            <div className="left mt-5">
                                {" "}
                                {id != null && (
                                    <Link
                                        to={`/${is_lead ? "lead" : "client"}/${
                                            client.client_id
                                        }?meeting_id=${meeting_id}&meeting_type_id=${meeting_type}`}
                                        key={meeting_id}
                                    >
                                        <a
                                            className={`text-xs text-white border border-gray-400 font-semibold ${
                                                is_visited
                                                    ? "bg-gray-400"
                                                    : "bg-black"
                                            } cursor-pointer hover:bg-buttonMainHoverBackground hover:text-buttonMainHoverFontColor px-3 py-2 mx-auto mt-3 rounded-full`}
                                        >
                                            {" "}
                                            <FormattedMessage
                                                id={
                                                    is_visited
                                                        ? "routing.client_page"
                                                        : "routing.start_visit"
                                                }
                                                values={{
                                                    number: 1,
                                                }}
                                            />
                                        </a>
                                    </Link>
                                )}
                            </div>
                        </div>{" "}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DraggableMeetingList;
